angular.module("ainapp").controller("reportConfigurationController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService",
    "localStorageService", "$window", function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

        $scope.PageName = "Report Configuration";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.getCurrentData = function () {
            $scope.selectedItems = [];

            $scope.fields = [
                {
                    field: "Id",
                    title: "Id",
                    type: "number",
                    hidden: true
                },
                {
                    field: "VoucherNumber",
                    title: "Voucher No",
                        
                },
                {
                    field: "Remarks",
                    title: "Remarks",
                    type: "string"
                },
                {
                    field: "Date",
                    title: "Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "IsApproved",
                    title: "Approved",
                    type: "boolean"
                },
                {
                    field: "LinkedRefNos",
                    title: "Linked Ref Nos",
                    type: "string"
                },
                {
                    field: "AddDiscountPer",
                    title: "Add Disc %",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(AddDiscountPer, 'n')#</div>"
                },
                {
                    field: "AddDiscount",
                    title: "Add Disc",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(AddDiscount, 'n')#</div>"
                },
                {
                    field: "TotalQuantity",
                    title: "Total Quantity",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalQuantity, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Total Quantity</div>")
                },
                {
                    field: "TotalDiscount",
                    title: "Total Discount",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalDiscount, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Total Discount</div>")
                },
                {
                    field: "GrossTotal",
                    title: "Gross Total",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(GrossTotal, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Gross Total</div>")
                },
                {
                    field: "TotalOtherCharges",
                    title: "Total Other Charges",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalOtherCharges, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Total Other Ch</div>")
                },
                {
                    field: "NetTotal",
                    title: "Net Total",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(NetTotal, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Net Total</div>")
                },
                {
                    field: "TotalTax",
                    title: "Total Tax",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Total Tax</div>")
                },
                {
                    field: "TotalExtraCharges",
                    title: "Total Extra Charges",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalExtraCharges, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Total Extra Ch</div>")
                },
                {
                    field: "GrandTotal",
                    title: "Grand Total",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>GrandTotal</div>")
                },
                {
                    field: "CalcGrandTotal",
                    title: "Calc Grand Total",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(CalcGrandTotal, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Calc Grand Total</div>")
                },
                {
                    field: "ConversionRate",
                    title: "Conversion Rate",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(ConversionRate, 'n')#</div>"
                },
                {
                    field: "AdvancePer",
                    title: "Advance %",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(AdvancePer, 'n')#</div>"
                },
                {
                    field: "Advance",
                    title: "Advance",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(Advance, 'n')#</div>"
                },
                {
                    field: "AdvanceVAT",
                    title: "Advance VAT",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(AdvanceVAT, 'n')#</div>"
                },
                {
                    field: "Revision",
                    title: "Revision",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(Revision, 'n')#</div>"
                },
                {
                    field: "CreatedBy.UserName",
                    title: "Created By",
                    type: "string"
                },
                {
                    field: "CreatedDate",
                    title: "Created Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "UpdatedBy.UserName",
                    title: "Updated By",
                    type: "string"
                },
                {
                    field: "UpdatedDate",
                    title: "Updated Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "DueDate",
                    title: "Due Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "DueDays",
                    title: "Due Days",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(DueDays, 'n')#</div>"
                },
                {
                    field: "Customer.Name",
                    title: "Customer",
                    type: "string"
                },
                {
                    field: "Customer.MobileNo",
                    title: "Mob No",
                    type: "string"
                },
                {
                    field: "Customer.TRNNo",
                    title: "TRN No",
                    type: "string"
                },
                {
                    field: "BaseCurrency.Name",
                    title: "Currency",
                    type: "string"
                },
                {
                    field: "Branch.Name",
                    title: "Branch",
                    type: "string"
                },
                {
                    field: "IntroLetterDescription",
                    title: "Intro Letter",
                    type: "string"
                },
                {
                    field: "EndLetterDescription",
                    title: "End Letter",
                    type: "string"
                },
                {
                    field: "SupplierQtnNo",
                    title: "Supplier Qtn No",
                    type: "string"
                },
                {
                    field: "WeightDimension",
                    title: "Weight Dimension",
                    type: "string"
                },
                {
                    field: "Validity",
                    title: "Validity",
                    type: "string"
                },
                {
                    field: "ContactPerson",
                    title: "Contact Person",
                    type: "string"
                },
                {
                    field: "SupplyPlace",
                    title: "Supply Place",
                    type: "string"
                },
                {
                    field: "ShippingAddress",
                    title: "Shipping Address",
                    type: "string"
                },
                {
                    field: "SupplierBillNo",
                    title: "Supplier Bill No",
                    type: "string"
                },
                {
                    field: "SupplierQtnNo",
                    title: "Supplier Qtn No",
                    type: "string"
                },
                {
                    field: "WeightDimension",
                    title: "Weight Dimension",
                    type: "string"
                },
                {
                    field: "NoOfPackages",
                    title: "No Of Packages",
                    type: "string"
                },
                {
                    field: "TotalGrossWeight",
                    title: "Total Gross Weight",
                    type: "string"
                },
                {
                    field: "Total Net Weight",
                    title: "Total Net Weight",
                    type: "string"
                },
                {
                    field: "EnquiryNo",
                    title: "Enquiry No",
                    type: "string"
                },
                {
                    field: "OrderNo",
                    title: "Order No",
                    type: "string"
                },
                {
                    field: "WarrantyPeriod",
                    title: "Warranty Period",
                    type: "string"
                },
                {
                    field: "DeliveryPeriod",
                    title: "Delivery Period",
                    type: "string"
                },
                {
                    field: "DeliveryBasis",
                    title: "Delivery Basis",
                    type: "string"
                },
                {
                    field: "PaymentTerms",
                    title: "Payment Terms",
                    type: "string"
                },
                {
                    field: "DeliveryDate",
                    title: "Delivery Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "DeliveryTime",
                    title: "Delivery Time",
                    type: "string"
                },
                {
                    field: "ReturnDate",
                    title: "Return Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "ReturnTime",
                    title: "Return Time",
                    type: "string"
                },
                {
                    field: "SupplierBillDate",
                    title: "Supplier Bill Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "CustomerPONo",
                    title: "Customer PO No",
                    type: "string"
                },
                {
                    field: "SupplierPONO",
                    title: "Supplier PO NO",
                    type: "string"
                },
                {
                    field: "Employee.Name",
                    title: "Employee",
                    type: "string"
                },
                {
                    field: "AccountContact.Name",
                    title: "Customer Contact",
                    type: "string"
                },
                {
                    field: "AccountAddress.Address1",
                    title: "Customer Address",
                    type: "string"
                },

                {
                    field: "TotalCost",
                    title: "Cost",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalCost, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Total Other Ch</div>")
                },
                {
                    field: "TotalProfit",
                    title: "Profit",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalProfit, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Profit</div>")
                },
                {
                    field: "ProfitPer",
                    title: "Profit %",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(ProfitPer, 'n')#</div>"
                }
            ];

            $scope.detailFields = [
                {
                    field: "Id",
                    title: "Id",
                    type: "number",
                    hidden: true
                },
                {
                    field: "Quantity",
                    title: "Quantity",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(Quantity, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Quantity</div>")
                },
                {
                    field: "remarks",
                    title: "remarks",
                    type: "string"
                },
                {
                    field: "Remarks",
                    title: "Remarks",
                    type: "string"
                },
                {
                    field: "VatType",
                    title: "Vat Type",
                    type: "string"
                },
                {
                    field: "DiscountType",
                    title: "Discount Type",
                    type: "string"
                },
                {
                    field: "UnitPrice",
                    title: "Unit Price",
                    type: "number"
                },
                {
                    field: "DiscountValue",
                    title: "Discount Value",
                    type: "number"
                },
                {
                    field: "Cost",
                    title: "Cost",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(Cost, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Cost</div>")
                },
                {
                    field: "TCost",
                    title: "TCost",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TCost, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>TCost</div>")
                },
                {
                    field: "Discount",
                    title: "Discount",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(Discount, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Discount</div>")
                },
                {
                    field: "TaxValue",
                    title: "Tax Value",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TaxValue, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Tax Amount</div>")
                },
                {
                    field: "Total",
                    title: "Gross",
                    type: "number",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(Total, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Gross</div>")
                },
                {
                    field: "LinkedQty",
                    title: "Linked Qty",
                    type: "number"
                },
                {
                    field: "BalanceQty",
                    title: "Balance Qty",
                    type: "number"
                },
                {
                    field: "OtherCharges",
                    title: "Other Charges",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(OtherCharges, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Other Charges</div>")
                },
                {
                    field: "LinkPer",
                    title: "Link Per",
                    type: "number"
                },
                {
                    field: "ActualQty",
                    title: "Actual Qty",
                    type: "number"
                },
                {
                    field: "Vat1Per",
                    title: "Vat 1 Per",
                    type: "number"
                },
                {
                    field: "Vat1Value",
                    title: "Vat1Value",
                    type: "number"
                },
                {
                    field: "Vat2Per",
                    title: "Vat 2 Per",
                    type: "number"
                },
                {
                    field: "Vat2Value",
                    title: "Vat2Value",
                    type: "number"
                },
                {
                    field: "Vat3Per",
                    title: "Vat 3 Per",
                    type: "number"
                },
                {
                    field: "Vat3Value",
                    title: "Vat3Value",
                    type: "number"
                },
                {
                    field: "Vat4Per",
                    title: "Vat 4 Per",
                    type: "number"
                },
                {
                    field: "Vat4Value",
                    title: "Vat4Value",
                    type: "number"
                },
                {
                    field: "Vat5Per",
                    title: "Vat 5 Per",
                    type: "number"
                },
                {
                    field: "Vat5Value",
                    title: "Vat5Value",
                    type: "number"
                },
                {
                    field: "AssessableValue",
                    title: "Assessable Value",
                    type: "number"
                },
                {
                    field: "TaxableAmount",
                    title: "Taxable Amount",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TaxableAmount, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Taxable Amount</div>")
                },
                {
                    field: "RoundOfVat",
                    title: "Round Of Vat",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(RoundOfVat, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Round Of Vat</div>")
                },
                {
                    field: "QCost",
                    title: "QCost",
                    type: "number"
                },
                {
                    field: "Bonus",
                    title: "Bonus",
                    type: "number"
                },
                {
                    field: "ExtraCharges",
                    title: "ExtraCharges",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(ExtraCharges, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Extra Charges</div>")
                },
                {
                    field: "YRRefNo",
                    title: "YRRefNo",
                    type: "string"
                },
                {
                    field: "Manufacturing",
                    title: "Manufacturing",
                    type: "string"
                },
                {
                    field: "Stock",
                    title: "Stock",
                    type: "string"
                },
                {
                    field: "TotalProfit",
                    title: "Profit",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(TotalProfit, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Profit</div>")
                },
                {
                    field: "ProfitPer",
                    title: "Profit %",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(ProfitPer, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Profit %</div>")
                },
                {
                    field: "NetWeight",
                    title: "Net Weight",
                    type: "number"
                },
                {
                    field: "GrossWeight",
                    title: "Gross Weight",
                    type: "number"
                },
                {
                    field: "TotalNetWeight",
                    title: "Total Net Weight",
                    type: "number"
                },
                {
                    field: "TotalGrossWeight",
                    title: "Total Gross Weight",
                    type: "number"
                },
                {
                    field: "FocQuantity",
                    title: "Foc Quantity",
                    type: "number"
                },
                {
                    field: "InventoryValue",
                    title: "Grand Total",
                    type: "number",
                    template: "<div style='text-align: right'>#=kendo.toString(InventoryValue, 'n')#</div>",
                    aggregates: ["sum"],
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    headerTemplate: kendo.template("<div class='headerright'>Grand Total</div>")
                },
                {
                    field: "Unit.Name",
                    title: "Unit",
                    type: "string"
                },
                {
                    field: "Master6.Name",
                    title: "Master6",
                    type: "string"
                },
                {
                    field: "Master7.Name",
                    title: "Master7",
                    type: "string"
                },
                {
                    field: "Master8.Name",
                    title: "Master8",
                    type: "string"
                },
                {
                    field: "Warehouse.Name",
                    title: "Warehouse",
                    type: "string"
                },
                {
                    field: "Country.Name",
                    title: "Country",
                    type: "string"
                },
                {
                    field: "Brand.Name",
                    title: "Brand",
                    type: "string"
                },
                {
                    field: "VAT.Name",
                    title: "VAT",
                    type: "string"
                },
                {
                    field: "Product.Name",
                    title: "Product Name",
                    type: "string"
                },
                {
                    field: "Product.ProductCode",
                    title: "Product Code",
                    type: "string"
                },
                {
                    field: "Product.Parent.Name",
                    title: "Product Parent",
                    type: "string"
                },
                {
                    field: "Product.Parent.Parent.Name",
                    title: "Product Group",
                    type: "string"
                },
                // product additional fields
                {
                    field: "Product.Field1",
                    title: "Product Field1",
                    type: "string"
                },
                {
                    field: "Product.Field2",
                    title: "Product Field2",
                    type: "string"
                },



                // Invoice
                {
                    field: "VoucherDataId",
                    title: "Voucher Id",
                    type: "string",
                    hidden: true
                },
                {
                    field: "VoucherData.VoucherNumber",
                    title: "Voucher No",
                    type: "string"
                },
                {
                    field: "VoucherData.Date",
                    title: "Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(VoucherData.Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "VoucherData.IsApproved",
                    title: "Approved",
                    type: "boolean"
                },
                {
                    field: "VoucherData.LinkedRefNos",
                    title: "Linked Ref Nos",
                    type: "string"
                },

                {
                    field: "VoucherData.CreatedBy.UserName",
                    title: "Created By",
                    type: "string"
                },
                {
                    field: "VoucherData.CreatedDate",
                    title: "Created Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(VoucherData.CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "VoucherData.UpdatedBy.UserName",
                    title: "Updated By",
                    type: "string"
                },
                {
                    field: "VoucherData.UpdatedDate",
                    title: "Updated Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(VoucherData.UpdatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },

                {
                    field: "VoucherData.Customer.Name",
                    title: "Customer",
                    type: "string"
                },
                {
                    field: "VoucherData.Customer.MobileNo",
                    title: "Customer Mob No",
                    type: "string"
                },
                {
                    field: "VoucherData.BaseCurrency.Name",
                    title: "Currency",
                    type: "string"
                },
                {
                    field: "VoucherData.Branch.Name",
                    title: "Branch",
                    type: "string"
                },
                {
                    field: "VoucherData.CustomerPONo",
                    title: "Customer PO No",
                    type: "string"
                },
                {
                    field: "VoucherData.SupplierPONO",
                    title: "Supplier PO NO",
                    type: "string"
                },
                {
                    field: "VoucherData.Employee.Name",
                    title: "Employee",
                    type: "string"
                },
            ];

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType($scope.SelectedVoucher).then(function (response) {
                $scope.VDesign = response.data;

                if (1 == 1) {
                    if ($scope.VDesign.IsField1) {
                        var f = {
                            field: "Field1",
                            title: $scope.VDesign.Field1,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField2) {
                        var f = {
                            field: "Field2",
                            title: $scope.VDesign.Field2,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField3) {
                        var f = {
                            field: "Field3",
                            title: $scope.VDesign.Field3,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField4) {
                        var f = {
                            field: "Field4",
                            title: $scope.VDesign.Field4,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField5) {
                        var f = {
                            field: "Field5",
                            title: $scope.VDesign.Field5,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField6) {
                        var f = {
                            field: "Field6",
                            title: $scope.VDesign.Field6,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField7) {
                        var f = {
                            field: "Field7",
                            title: $scope.VDesign.Field7,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField8) {
                        var f = {
                            field: "Field8",
                            title: $scope.VDesign.Field8,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField9) {
                        var f = {
                            field: "Field9",
                            title: $scope.VDesign.Field9,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField10) {
                        var f = {
                            field: "Field10",
                            title: $scope.VDesign.Field10,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField11) {
                        var f = {
                            field: "Field11",
                            title: $scope.VDesign.Field11,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField12) {
                        var f = {
                            field: "Field12",
                            title: $scope.VDesign.Field12,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField13) {
                        var f = {
                            field: "Field13",
                            title: $scope.VDesign.Field13,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField14) {
                        var f = {
                            field: "Field14",
                            title: $scope.VDesign.Field14,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField15) {
                        var f = {
                            field: "Field15",
                            title: $scope.VDesign.Field15,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField16) {
                        var f = {
                            field: "Field16",
                            title: $scope.VDesign.Field16,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field16, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField17) {
                        var f = {
                            field: "Field17",
                            title: $scope.VDesign.Field17,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field17, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField18) {
                        var f = {
                            field: "Field18",
                            title: $scope.VDesign.Field18,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field18, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField19) {
                        var f = {
                            field: "Field19",
                            title: $scope.VDesign.Field19,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(IsField19, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField20) {
                        var f = {
                            field: "Field20",
                            title: $scope.VDesign.Field20,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(IsField20, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField21) {
                        var f = {
                            field: "Field21",
                            title: $scope.VDesign.Field21,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField22) {
                        var f = {
                            field: "Field22",
                            title: $scope.VDesign.Field22,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField23) {
                        var f = {
                            field: "Field23",
                            title: $scope.VDesign.Field23,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField24) {
                        var f = {
                            field: "Field24",
                            title: $scope.VDesign.Field24,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField25) {
                        var f = {
                            field: "Field25",
                            title: $scope.VDesign.Field25,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField26) {
                        var f = {
                            field: "Field26",
                            title: $scope.VDesign.Field26,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }

                    if ($scope.VDesign.IsField27) {
                        var f = {
                            field: "Field27",
                            title: $scope.VDesign.Field27,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }

                    if ($scope.VDesign.IsField28) {
                        var f = {
                            field: "Field28",
                            title: $scope.VDesign.Field28,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }

                    if ($scope.VDesign.IsField29) {
                        var f = {
                            field: "Field29",
                            title: $scope.VDesign.Field29,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }

                    if ($scope.VDesign.IsField30) {
                        var f = {
                            field: "Field30",
                            title: $scope.VDesign.Field30,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                }

                /// Details fields

                if (1 == 1) {
                    if ($scope.VDesign.IsDField1) {
                        var f = {
                            field: "Field1",
                            title: $scope.VDesign.DField1,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField2) {
                        var f = {
                            field: "Field2",
                            title: $scope.VDesign.DField2,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField3) {
                        var f = {
                            field: "Field3",
                            title: $scope.VDesign.DField3,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField4) {
                        var f = {
                            field: "Field4",
                            title: $scope.VDesign.DField4,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField5) {
                        var f = {
                            field: "Field5",
                            title: $scope.VDesign.DField5,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField6) {
                        var f = {
                            field: "Field6",
                            title: $scope.VDesign.DField6,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField7) {
                        var f = {
                            field: "Field7",
                            title: $scope.VDesign.DField7,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField8) {
                        var f = {
                            field: "Field8",
                            title: $scope.VDesign.DField8,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField9) {
                        var f = {
                            field: "Field9",
                            title: $scope.VDesign.DField9,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField10) {
                        var f = {
                            field: "Field10",
                            title: $scope.VDesign.DField10,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField11) {
                        var f = {
                            field: "Field11",
                            title: $scope.VDesign.DField11,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField12) {
                        var f = {
                            field: "Field12",
                            title: $scope.VDesign.DField12,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField13) {
                        var f = {
                            field: "Field13",
                            title: $scope.VDesign.DField13,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField14) {
                        var f = {
                            field: "Field14",
                            title: $scope.VDesign.DField14,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField15) {
                        var f = {
                            field: "Field15",
                            title: $scope.VDesign.DField15,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField16) {
                        var f = {
                            field: "Field16",
                            title: $scope.VDesign.DField16,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field16, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField17) {
                        var f = {
                            field: "Field17",
                            title: $scope.VDesign.DField17,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field17, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField18) {
                        var f = {
                            field: "Field18",
                            title: $scope.VDesign.DField18,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field18, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField19) {
                        var f = {
                            field: "Field19",
                            title: $scope.VDesign.DField19,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field19, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField20) {
                        var f = {
                            field: "Field20",
                            title: $scope.VDesign.DField20,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field20, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.detailFields.push(f);
                    }
                    if ($scope.VDesign.IsDField21) {
                        var f = {
                            field: "Field21",
                            title: $scope.VDesign.DField21,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField22) {
                        var f = {
                            field: "Field22",
                            title: $scope.VDesign.DField22,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField23) {
                        var f = {
                            field: "Field23",
                            title: $scope.VDesign.DField23,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField24) {
                        var f = {
                            field: "Field24",
                            title: $scope.VDesign.DField24,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField25) {
                        var f = {
                            field: "Field25",
                            title: $scope.VDesign.DField25,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField26) {
                        var f = {
                            field: "Field26",
                            title: $scope.VDesign.DField26,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField27) {
                        var f = {
                            field: "Field27",
                            title: $scope.VDesign.DField27,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField28) {
                        var f = {
                            field: "Field28",
                            title: $scope.VDesign.DField28,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField29) {
                        var f = {
                            field: "Field29",
                            title: $scope.VDesign.DField29,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsDField30) {
                        var f = {
                            field: "Field30",
                            title: $scope.VDesign.DField30,
                            type: "number",
                        };
                        $scope.detailFields.push(f);
                    }

                }

                if ($scope.selectedVoucherName == "Purchase Invocie" || $scope.selectedVoucherName == "Import Purchase Invoice") {
                    if ($scope.VDesign.IsFrieghtCharges) {
                        var f = {
                            field: "FrieghtCharges",
                            title: "Frieght Charges",
                            type: "number",
                            template: "<div style='text-align: right'>#=kendo.toString(FrieghtCharges, 'n')#</div>",
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Frieght Charges</div>")
                        };
                        $scope.detailFields.push(f);
                    }
                }

                if ($scope.selectedVoucherName == "Import Purchase Invoice") {
                    if ($scope.VDesign.IsClearingCharges) {
                        var f = {
                            field: "ClearingCharges",
                            title: "Clearing Charges",
                            type: "number",
                            template: "<div style='text-align: right'>#=kendo.toString(ClearingCharges, 'n')#</div>",
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Clearing Charges</div>")
                        };
                        $scope.detailFields.push(f);
                    }
                }

                if ($scope.selectedVoucherName == "Import Purchase Invoice") {
                    if ($scope.VDesign.IsDutyCharges) {
                        var f = {
                            field: "DutyCharges",
                            title: "Duty Charges",
                            type: "number",
                            template: "<div style='text-align: right'>#=kendo.toString(DutyCharges, 'n')#</div>",
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Duty Charges</div>")
                        };
                        $scope.detailFields.push(f);
                    }
                }

                if ($scope.selectedVoucherName == "Import Purchase Invoice") {
                    if ($scope.VDesign.IsDeliveryCharges) {
                        var f = {
                            field: "DeliveryCharges",
                            title: "Delivery Charges",
                            type: "number",
                            template: "<div style='text-align: right'>#=kendo.toString(DeliveryCharges, 'n')#</div>",
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Delivery Charges</div>")
                        };
                        $scope.detailFields.push(f);
                    }
                }

                if ($scope.selectedVoucherName == "Purchase Invoice") {
                    if ($scope.VDesign.IsPackingCharges) {
                        var f = {
                            field: "PackingCharges",
                            title: "Packing Charges",
                            type: "number",
                            template: "<div style='text-align: right'>#=kendo.toString(PackingCharges, 'n')#</div>",
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Packing Charges</div>")
                        };
                        $scope.detailFields.push(f);
                    }
                }

                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response2) {
                    $scope.CompanyProfile = response2.data;

                    if ($scope.VDesign.IsMaster1) {
                        var f = {
                            field: "Master1.Name",
                            title: $scope.CompanyProfile.Master1Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsMaster2) {
                        var f = {
                            field: "Master2.Name",
                            title: $scope.CompanyProfile.Master2Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsMaster3) {
                        var f = {
                            field: "Master3.Name",
                            title: $scope.CompanyProfile.Master3Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsMaster4) {
                        var f = {
                            field: "Master4.Name",
                            title: $scope.CompanyProfile.Master4Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsMaster5) {
                        var f = {
                            field: "Master5.Name",
                            title: $scope.CompanyProfile.Master5Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }

                    if ($scope.VDesign.IsMaster6) {
                        var f = {
                            field: "Master6.Name",
                            title: $scope.CompanyProfile.Master6Name,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsMaster7) {
                        var f = {
                            field: "Master7.Name",
                            title: $scope.CompanyProfile.Master7Name,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    if ($scope.VDesign.IsMaster8) {
                        var f = {
                            field: "Master8.Name",
                            title: $scope.CompanyProfile.Master8Name,
                            type: "string"
                        };
                        $scope.detailFields.push(f);
                    }

                    $.LoadingOverlay("show", {
                        image: "images/load.gif"
                    });

                    $scope.CurrentReportConfig = {};
                    MainService.ReportConfigsbyType($scope.SelectedVoucher, $scope.SelectedVoucherType).then(
                        function (response3) {
                            if (response3.data != null && response3.data != "") {
                                $scope.CurrentReportConfig = response3.data;
                                var array = JSON.parse($scope.CurrentReportConfig.TableArray);
                                $scope.selectedItems = array;
                            }
                            $.LoadingOverlay("hide");
                        },
                        function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        }
                    );
                });

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher($scope.SelectedVoucher).then(function (response4) {
                    $scope.CostCenters = response4.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, "");
                        field = field.replace("&", "");
                        field = field.replace("/", "");
                        field = field.replace(".", "");

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            type: "string"
                        };
                        $scope.fields.push(clm);
                        $scope.detailFields.push(clm);
                    });

                    $scope.fields2 = angular.copy($scope.fields);
                    $scope.detailFields2 = angular.copy($scope.detailFields);
                });
            });

            //                 var options = {
            //                            title: "Options",
            //                            headerTemplate: "{{LanguageData.Options}}  ",
            //                            template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.DeliveryNote.Id, \"Delivery Note\")'></button>",
            //                            width: '100px',
            //                            sticky: true
            //                        };
        };

        $scope.init = function () {
            $scope.ViewVal2 = 0;
            $scope.ViewVal = 0;
            $scope.selectedVoucherName = "Material Request";
            $scope.SelectedVoucher = "Material Request";
            $scope.SelectedVoucherType = "ListView";
            $scope.selectedItems = [];
            $scope.getCurrentData();
        };
        $scope.init();

        // Array to hold selected items with title
        $scope.selectedItems = [];

        // Function to add a new item selection row
        $scope.addItem = function () {
            $scope.selectedItems.push({
                field: "",
                type: "",
                title: ""
            });
        };

        // Function to remove an item selection row
        $scope.removeItem = function (data) {
            var index = $scope.selectedItems.indexOf(data);
            $scope.selectedItems.splice(index, 1);
        };

        // Function to update the type when a field is selected
        $scope.updateType = function (item) {
            angular.forEach($scope.fields, function (e) {
                if (item.field == e.field) {
                    item.selectedField = e;
                    item.type = e.type;
                    item.title = e.title;
                }
            });
        };

        $scope.switchTab = function (id, type, voucher) {
            $scope.selectedVoucherName = voucher;
            $scope.ViewVal = id;
            $scope.SelectedVoucher = type;
            $scope.getCurrentData();
        };

        $scope.switchTab1 = function (id, type) {
            $scope.ViewVal2 = id;
            $scope.SelectedVoucherType = type;
            $scope.getCurrentData();
        };

        $scope.saveConfiguration = function () {
            $.LoadingOverlay("show", {
                image: "images/load.gif"
            });

            $scope.result = [];

            if ($scope.SelectedVoucherType != "Detail") {
                $scope.selectedItems.forEach(function (e) {
                    $scope.fields2.forEach(function (item) {
                        if (item.field == e.field) {
                            //                            $scope.result.push({
                            //                                field: e.field,
                            //                                type: item.type,
                            //                                title: item.title
                            //                            })
                            $scope.result.push(item);
                        }
                    });
                });
            } else {
                $scope.selectedItems.forEach(function (e) {
                    $scope.detailFields2.forEach(function (item) {
                        if (item.field == e.field) {
                            //                            $scope.result.push({
                            //                                field: e.field,
                            //                                type: item.type,
                            //                                title: item.title
                            //                            })
                            $scope.result.push(item);
                        }
                    });
                });
            }

            var configData = {
                VoucherName: $scope.SelectedVoucher,
                ViewType: $scope.SelectedVoucherType,
                TableArray: JSON.stringify($scope.result)
            };

            MainService.AddReportConfig(configData).then(
                function (response) {
                    if (response.data) {
                        toastr.success("Success");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }
            );
        };

        $scope.copiedSelectedItems = {};
        $scope.copyConfig = function (data) {
            $scope.copiedSelectedItems = angular.copy(data);
        };

        $scope.pasteConfig = function () {
            $scope.selectedItems = angular.copy($scope.copiedSelectedItems);
        };
    }
]);
